// extracted by mini-css-extract-plugin
export default {"dashboardGrid":"ClientMainPage_dashboardGrid__Wkn45","topRow":"ClientMainPage_topRow__apcPY","bottomRow":"ClientMainPage_bottomRow__ZyhRA","title":"ClientMainPage_title__+5uuu"};